import { mctRequest } from '@/api/axios'

export const groupListApi = <T = any>(params: string): Promise<T> => {
  const config = {
    url: `/agent/queryAgentOrg${params}`
  }
  return mctRequest.request<T>(config)
}
